import React from 'react';
import { MessageCircle } from 'lucide-react';

interface ChatbotIconProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const ChatbotIcon: React.FC<ChatbotIconProps> = ({
  size = 'md',
  className = '',
}) => {
  const getSizeClass = () => {
    switch (size) {
      case 'sm':
        return 'h-5 w-5';
      case 'md':
        return 'h-6 w-6';
      case 'lg':
        return 'h-8 w-8';
      default:
        return 'h-6 w-6';
    }
  };

  return (
    <MessageCircle className={`${getSizeClass()} ${className}`} />
  );
};

export default ChatbotIcon;



